import { useIdentityRoles } from '@/js/libs/use-auth';

import { POST_ENDPOINTS } from 'src/modules/PostCampaign/index.ts';

// Returns the Post portal a Post user on a Post host leaves for on logout; anyone else stays in the app.
export const useLogoutRedirectPath = (): string | undefined => {
  const { POSTADMANAGER, POSTNETZ } = useIdentityRoles();
  const isPostUser = POSTADMANAGER || POSTNETZ;

  return isPostUser && POST_ENDPOINTS.includes(window.location.host) ? import.meta.env.VITE_POST_LOGOUT_ENDPOINT : undefined;
};
